import ShowroomList from './ShowroomList.vue';
import ArticleList from './ArticleList.vue';
import BrandList from './BrandList.vue';

export default [
  {
    path: 'showroom',
    component: ShowroomList
  },
  {
    path: 'article',
    component: ArticleList
  },
  {
    path: 'brand',
    component: BrandList
  }
];